'use client'

import React from 'react'
import { GetUspResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { GET_USP_RESULT } from '@dustin-web/microsite-data/src/graphql/content/get-usp-content'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks/use-graphql'
import Link from 'next/link'
import { icons } from '@dustin-web/microsite-components/src/icon/icons'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'

export const UspBlock = () => {
  const { data, isValidating: loading } = useGraphql<GetUspResultQuery>(GET_USP_RESULT, {})

  if (!data && loading) {
    return null
  }

  const uspData = data?.usp

  if (!uspData?.usps) {
    return null
  }

  const isValidIconName = (iconString: string) => {
    if (!Object.prototype.hasOwnProperty.call(icons, iconString)) {
      return null
    }
    return iconString
  }

  return (
    <div className="u-bg-white c-usp">
      <div className="container">
        <div className="row d-flex flex-column flex-md-row align-items-md-start justify-content-between">
          {uspData.usps.map((usp, index) => (
            <div
              className={'col-md-4 u-w-auto d-flex flex-column c-usp--content'}
              key={usp.text + index}>
              {isValidIconName(usp.iconId) && (
                <Icon name={usp.iconId as IconName} className="i-32 d-block u-mb-16"></Icon>
              )}
              <Link
                prefetch={false}
                href={usp.link.url}
                className={'u-color-black u-fs-16 u-fw-bold u-button-opacity u-mb-8'}>
                {usp.link.text}
              </Link>
              <p className="p-sm u-mb-0">{usp.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
